<template>
  <div class="ng-swiper-lightbox">
    <ng-swiper
      class="ng-swiper-lightbox__gallery"
      v-bind="$attrs"
      v-on="$listeners"
      :images="[]"
      ref="gallery"
    >
      <slot name="gallery-slides">
        <template v-if="$attrs.images.length">
          <ng-swiper-slide
            class="ng-swiper-lightbox__gallery-slide"
            v-for="(image, index) in $attrs.images"
            :key="index"
            :caption="image[$attrs['caption-value']]"
            :caption-view="$attrs['caption-view']"
            :caption-outside="$attrs['caption-outside']"
            :caption-position="$attrs['caption-position']"
            :caption-attrs="$attrs['caption-attrs']"
            @click="showLightbox(index)"
          >
            <img
              class="ng-swiper__img"
              :src="image.src"
              :alt="image[$attrs.captionValue]"
              loading="lazy"
            />
          </ng-swiper-slide>
        </template>
      </slot>
    </ng-swiper>
    <transition name="fade">
      <div v-show="isLightboxOn" class="ng-swiper-lightbox__lightbox-wrapper">
        <ng-button
          class="ng-swiper-lightbox__lightbox-close"
          icon
          icon-name="mdi-close"
          @click="hideLightbox"
        ></ng-button>
        <ng-swiper
          lightbox
          class="ng-swiper-lightbox__lightbox"
          :images="$attrs.images"
          v-bind="lightboxAttrs"
          caption-view="chip"
          caption-value="caption_detailed"
          :options="lightboxOptionsDefault"
          :navigation="$attrs.images.length > 1"
          ref="lightbox"
        >
          <slot name="lightbox-slides"></slot>
        </ng-swiper>
      </div>
    </transition>
  </div>
</template>

<script>
import NgSwiper from './NgSwiper.vue';
import NgSwiperSlide from './NgSwiperSlide.vue';

export default {
  name: 'NgSwiperLightbox',
  components: { NgSwiper, NgSwiperSlide },
  props: {
    lightboxAttrs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      lightboxOptionsDefault: {
        loop: true,
        sliderPerView: 1,
      },
      isLightboxOn: false,
    };
  },
  mounted() {
    window.addEventListener(
      'keydown',
      (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
          if (this.isLightboxOn) this.hideLightbox();
        }
        if (e.key === 'ArrowLeft' || e.key === 'Left') {
          if (this.isLightboxOn) this.lightboxSlidePrev();
        }
        if (e.key === 'ArrowRight' || e.key === 'Right') {
          if (this.isLightboxOn) this.lightboxSlideNext();
        }
      },
      true,
    );
  },
  methods: {
    preventDefault(e) {
      e.preventDefault();
    },
    showLightbox(index) {
      this.isLightboxOn = true;
      this.$nextTick(() => {
        this.$refs.lightbox.slideTo(index + 1);
      });
      this.$el.addEventListener('mousewheel', this.preventDefault);
      this.$emit('show:lightbox');
    },
    hideLightbox() {
      this.isLightboxOn = false;
      this.$el.removeEventListener('mousewheel', this.preventDefault, false);
      this.$emit('hide:lightbox');
    },
    slideNext() {
      this.$refs.gallery.next();
    },
    slidePrev() {
      this.$refs.gallery.prev();
    },
    lightboxSlideNext() {
      this.$refs.lightbox.next();
    },
    lightboxSlidePrev() {
      this.$refs.lightbox.prev();
    },
  },
};
</script>

<style lang="scss" scoped>
.ng-swiper-lightbox__lightbox-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  background-color: #212121;
  //display: none;
}

.ng-swiper-lightbox__lightbox {
  display: flex;
  //align-items: center;
  justify-content: center;
  height: 100%;

  &::v-deep .ng-swiper-slide {
    //align-items: center;
    //justify-content: center;
    height: auto;
    align-self: center;
    max-height: 100%;
  }

  &::v-deep .ng-swiper__img {
    @media (min-width: map-get($grid-breakpoints, 'md')) {
      max-width: 90vw;
    }
  }
}

.ng-swiper-lightbox__lightbox-close {
  position: fixed;
  right: 12px;
  top: 12px;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.6) !important;
  color: #fff !important;
}

.ng-swiper-lightbox__gallery-slide {
  cursor: zoom-in;
}
</style>
